export default __webpack_public_path__ + "94ed8b70f61297e5f2012390e96fb4a9.jpg";